import { NavigationMenuLink } from "@radix-ui/react-navigation-menu";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

import { type CallDisplayMode, useCallContext } from "./CallContext";

export function CallModeMenu() {
  const { activeMode, setActiveMode } = useCallContext();
  return (
    <NavigationMenu
      value={activeMode}
      onValueChange={(value) => {
        if (
          [
            "ai",
            "transcript",
            "script",
            "participants",
            "summary",
            "report",
          ].includes(value)
        ) {
          setActiveMode(value as CallDisplayMode);
        }
      }}
    >
      <NavigationMenuList>
        <NavigationMenuItem value="script">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "script" ? "border border-gray-300 font-bold" : ""
            }`}
            onClick={() => {
              setActiveMode("script");
            }}
          >
            Call
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="participants">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "participants"
                ? "border border-gray-300 font-bold"
                : ""
            }`}
            onClick={() => {
              setActiveMode("participants");
            }}
          >
            Participants
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="ai">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "ai" ? "border border-gray-300 font-bold" : ""
            }`}
            onClick={() => {
              setActiveMode("ai");
            }}
          >
            AI
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="transcript">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "transcript"
                ? "border border-gray-300 font-bold"
                : ""
            }`}
            onClick={() => {
              setActiveMode("transcript");
            }}
          >
            Transcript
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
